import { FormGroup } from '@/components/ui/form'
import { getConfigFieldsByTileType } from '../config'
import { useDifficulties } from 'app/frontend/base/hooks/useDifficulties'
import { tileTypeToKey } from './TileWrapper'
import { useTranslation } from 'react-i18next'
import {
  OverviewTilePosition,
  OverviewTileType,
} from 'app/frontend/types/custom'
import TextField from 'app/frontend/base/components/form-fields/TextField'
import { useFormContext } from 'react-hook-form'

type Props = {
  namePrefix: string
  position: OverviewTilePosition
  tileType: OverviewTileType
}

const TileTypeOptions = ({ namePrefix, position, tileType }: Props) => {
  const { t } = useTranslation()
  const { watch } = useFormContext()
  const { difficulties, defaultDifficulty } = useDifficulties()
  const configFieldsByTileType = getConfigFieldsByTileType(
    difficulties,
    defaultDifficulty,
  )

  return (
    <>
      <TextField
        layout='stacked'
        name={`${namePrefix}.title`}
        customPlaceholder='Optional'
        customLabel='Title'
      />

      {configFieldsByTileType[tileType].map((configRow, configRowIndex) => {
        const visibleFields = configRow.filter((config) => {
          if (config.position && config.position !== position) return false
          if (config.showWhen) {
            const watchedValue = watch(`${namePrefix}.${config.showWhen.field}`)
            if (!config.showWhen.values.includes(watchedValue)) return false
          }
          return true
        })

        if (visibleFields.length === 0) return null

        return (
          <FormGroup
            key={`${tileType}-${configRowIndex}`}
            className={`grid grid-cols-${visibleFields.length}`}
          >
            {visibleFields.map((config) => (
              <div key={config.name} className='flex flex-col space-y-1.5'>
                <config.Component
                  {...config.fieldProps}
                  inModal={true}
                  layout={config.fieldProps?.layout ?? 'stacked'}
                  name={`${namePrefix}.${config.name}`}
                  configName={`${namePrefix}.${config.name}_config`}
                  customLabel={t(
                    `overview.tiles.${tileTypeToKey(tileType)}.config.${
                      config.name
                    }.label`,
                    { defaultValue: '' },
                  )}
                  customDescription={t(
                    `overview.tiles.${tileTypeToKey(tileType)}.config.${
                      config.name
                    }.description`,
                    { defaultValue: '' },
                  )}
                  customPlaceholder={t(
                    `overview.tiles.${tileTypeToKey(tileType)}.config.${
                      config.name
                    }.placeholder`,
                    { defaultValue: '' },
                  )}
                />
              </div>
            ))}
          </FormGroup>
        )
      })}
    </>
  )
}

export default TileTypeOptions
